(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-detail"]) return;
  try {
    
  document.querySelectorAll('[data-atelier]').forEach(function (root) {
    var input = root.querySelector('.atelier__qty-input input');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    var max = input && input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : NaN;

    function clamp(v) {
      v = Math.max(1, v || 1);
      if (!isNaN(max)) v = Math.min(max, v);
      return v;
    }
    if (input && minus && plus) {
      minus.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10)); });
    }

    var form = root.querySelector('.atelier__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            if (item && item.id) {
              document.dispatchEvent(new CustomEvent('oxalis:cart:add', { detail: { item: item } }));
              if (btn) btn.removeAttribute('disabled');
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-require-nonblank]').forEach(function (field) {
    function check() {
      var v = field.value;
      field.setCustomValidity(v.length > 0 && v.trim() === '' ? field.dataset.requireNonblank : '');
    }
    field.addEventListener('input', check);
    check();
  });

  document.querySelectorAll('[data-email-confirm]').forEach(function (confirmField) {
    var primary = document.getElementById(confirmField.dataset.emailConfirm);
    if (!primary) return;
    function check() {
      var a = primary.value.trim().toLowerCase();
      var b = confirmField.value.trim().toLowerCase();
      confirmField.setCustomValidity(b.length > 0 && a !== b ? confirmField.dataset.mismatchError : '');
    }
    confirmField.addEventListener('input', check);
    primary.addEventListener('input', check);
  });

  document.querySelectorAll('[data-email-typo-check]').forEach(function (field) {
    var wrap = field.closest('[data-email-field-wrap]');
    var suggestion = wrap && wrap.querySelector('[data-email-suggestion]');
    if (!suggestion) return;
    var textEl = suggestion.querySelector('[data-email-suggestion-text]');
    var applyBtn = suggestion.querySelector('[data-email-suggestion-apply]');

    // Common e-mail providers in Belgium and France — only used to
    // SUGGEST a likely typo fix, never to block or auto-correct. Any
    // domain not close to one of these (professional domains included)
    // is left alone, exactly as requested.
    var knownDomains = [
      'gmail.com', 'hotmail.com', 'hotmail.fr', 'hotmail.be',
      'outlook.com', 'outlook.fr', 'outlook.be', 'yahoo.com', 'yahoo.fr',
      'icloud.com', 'live.com', 'live.fr', 'live.be', 'aol.com',
      'protonmail.com', 'gmx.com', 'gmx.fr', 'skynet.be', 'telenet.be',
      'proximus.be', 'voo.be', 'scarlet.be', 'orange.fr', 'wanadoo.fr',
      'free.fr', 'sfr.fr', 'laposte.net', 'bbox.fr', 'numericable.fr'
    ];

    function levenshtein(a, b) {
      var m = a.length, n = b.length;
      var dp = [];
      for (var i = 0; i <= m; i++) {
        dp.push(new Array(n + 1).fill(0));
        dp[i][0] = i;
      }
      for (var j = 0; j <= n; j++) dp[0][j] = j;
      for (i = 1; i <= m; i++) {
        for (j = 1; j <= n; j++) {
          var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
        }
      }
      return dp[m][n];
    }

    function closestDomain(domain) {
      domain = domain.toLowerCase();
      if (knownDomains.indexOf(domain) !== -1) return null;
      var best = null, bestDist = Infinity;
      for (var i = 0; i < knownDomains.length; i++) {
        var d = levenshtein(domain, knownDomains[i]);
        if (d < bestDist) { bestDist = d; best = knownDomains[i]; }
      }
      return best && bestDist > 0 && bestDist <= 2 && domain.length >= 5 ? best : null;
    }

    function check() {
      var value = field.value.trim();
      var at = value.lastIndexOf('@');
      if (at === -1 || at === value.length - 1) { suggestion.hidden = true; return; }
      var local = value.slice(0, at);
      var domain = value.slice(at + 1);
      var match = closestDomain(domain);
      if (match) {
        textEl.textContent = suggestion.dataset.template.replace('{domain}', match);
        suggestion.hidden = false;
        applyBtn.onclick = function () {
          field.value = local + '@' + match;
          suggestion.hidden = true;
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.focus();
        };
      } else {
        suggestion.hidden = true;
      }
    }
    field.addEventListener('input', check);
    field.addEventListener('blur', check);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fleur-detail"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-family-variants]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-family-item]'));
      var grid = root.querySelector('.fleur-detail__variant-grid');
      var count = root.querySelector('[data-family-count]');
      var noMatch = root.querySelector('[data-family-no-match]');
      if (!items.length) return;

      /* ---------------- Couleur multi-select (item 30) ----------------
         Same OR-within-filter logic as the main referential page, scoped
         to this family's own variants only. */
      try {
        var dropdown = root.querySelector('[data-family-couleur-dropdown]');
        if (dropdown) {
          var checkboxes = Array.prototype.slice.call(dropdown.querySelectorAll('[data-family-couleur-option]'));
          var active = [];

          function summaryLabel() {
            if (active.length === 0) return 'Couleur';
            if (active.length === 1) {
              var cb = checkboxes.filter(function (c) { return c.value === active[0]; })[0];
              return cb ? cb.closest('label').querySelector('span').textContent : active[0];
            }
            return 'Couleur · ' + active.length;
          }

          function applyFilter() {
            var shown = 0;
            items.forEach(function (item) {
              var cols = (item.getAttribute('data-couleurs') || '').split(' ').filter(Boolean);
              var match = active.length === 0 || active.some(function (c) { return cols.indexOf(c) !== -1; });
              item.hidden = !match;
              if (match) shown++;
            });
            if (grid) grid.hidden = shown === 0;
            if (noMatch) noMatch.hidden = shown !== 0;
            if (count) {
              count.textContent = shown === items.length ? '' : shown + (shown > 1 ? ' variantes' : ' variante');
            }
            var label = root.querySelector('[data-family-couleur-summary]');
            if (label) label.textContent = summaryLabel();
          }

          var applyBtn = dropdown.querySelector('[data-family-couleur-apply]');
          if (applyBtn) {
            applyBtn.addEventListener('click', function () {
              active = checkboxes.filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; });
              applyFilter();
              dropdown.removeAttribute('open');
            });
          }
          var clearBtn = dropdown.querySelector('[data-family-couleur-clear]');
          if (clearBtn) {
            clearBtn.addEventListener('click', function () {
              active = [];
              checkboxes.forEach(function (cb) { cb.checked = false; });
              applyFilter();
            });
          }
        }
      } catch (e) {
        /* Couleur filter failed to initialize — every variant just stays
           visible, exactly as if no filter existed. */
      }

      /* ---------------- 2/1-column view toggle (mobile/tablet) ----------------
         Own localStorage key (item 11) — never reads or overwrites the
         main referential page's own "oxalis:flowers-view" preference. */
      try {
        var VIEW_KEY = 'oxalis:flowers-family-view';
        var viewToggle = root.querySelector('[data-family-view-toggle]');
        if (viewToggle) {
          var applyView = function (mode) {
            root.classList.toggle('fleur-detail__variants--full', mode === '1');
            viewToggle.querySelectorAll('[data-family-view-btn]').forEach(function (btn) {
              var isActive = btn.getAttribute('data-family-view-btn') === mode;
              btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
          };
          var savedView = '2';
          try {
            savedView = localStorage.getItem(VIEW_KEY) || '2';
          } catch (storageErr) {
            /* private mode / storage disabled — default view, harmless */
          }
          applyView(savedView);
          viewToggle.querySelectorAll('[data-family-view-btn]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var mode = btn.getAttribute('data-family-view-btn');
              applyView(mode);
              try {
                localStorage.setItem(VIEW_KEY, mode);
              } catch (storageErr) {
                /* best-effort only — the choice just won't persist */
              }
            });
          });
        }
      } catch (e) {
        /* View toggle failed to initialize — grid stays at its CSS
           default (2 columns on mobile/tablet). */
      }
    });

    /* ---------------- Bijoux correspondants — catégorie / prix / tri ----------------
       Entirely client-side over the real product cards Liquid already
       rendered server-side above (never a fetch, never a second product
       list) — category + price + sort only; Fleur/Signification are
       deliberately never filters here, the fleur is already fixed by
       this very page. */
    document.querySelectorAll('[data-fleur-shop]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-fleur-shop-item]'));
      var grid = root.querySelector('[data-fleur-shop-grid]');
      var emptyCategory = root.querySelector('[data-fleur-shop-empty-category]');
      if (!items.length || !grid) return;

      var activeType = '';
      var priceMin = null;
      var priceMax = null;

      function applyFilter() {
        var shown = 0;
        items.forEach(function (item) {
          var matchesType = activeType === '' || item.getAttribute('data-type') === activeType;
          var price = Number(item.getAttribute('data-price'));
          var matchesPrice = true;
          if (priceMin != null && !isNaN(priceMin)) matchesPrice = matchesPrice && price >= priceMin * 100;
          if (priceMax != null && !isNaN(priceMax)) matchesPrice = matchesPrice && price <= priceMax * 100;
          var match = matchesType && matchesPrice;
          item.hidden = !match;
          if (match) shown++;
        });
        if (emptyCategory) emptyCategory.hidden = shown !== 0;
        grid.hidden = shown === 0;
      }

      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-fleur-shop-chip]'));
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          activeType = chip.getAttribute('data-fleur-shop-chip');
          chips.forEach(function (c) {
            var isActive = c === chip;
            c.classList.toggle('chip--active', isActive);
            c.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          applyFilter();
        });
      });

      try {
        var priceDetails = root.querySelector('[data-fleur-shop-price]');
        var minInput = root.querySelector('[data-fleur-shop-price-min]');
        var maxInput = root.querySelector('[data-fleur-shop-price-max]');
        var applyBtn = root.querySelector('[data-fleur-shop-price-apply]');
        var clearBtn = root.querySelector('[data-fleur-shop-price-clear]');
        if (applyBtn) {
          applyBtn.addEventListener('click', function () {
            priceMin = minInput && minInput.value !== '' ? Number(minInput.value) : null;
            priceMax = maxInput && maxInput.value !== '' ? Number(maxInput.value) : null;
            applyFilter();
            if (priceDetails) priceDetails.removeAttribute('open');
          });
        }
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            priceMin = null;
            priceMax = null;
            if (minInput) minInput.value = '';
            if (maxInput) maxInput.value = '';
            applyFilter();
          });
        }
      } catch (e) {
        /* Price filter failed to initialize — every item just stays
           visible, exactly as if no filter existed. */
      }

      try {
        var sortSelect = root.querySelector('[data-fleur-shop-sort]');
        if (sortSelect) {
          sortSelect.addEventListener('change', function () {
            var mode = sortSelect.value;
            var sorted = items.slice();
            if (mode === 'price-asc') {
              sorted.sort(function (a, b) { return Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price')); });
            } else if (mode === 'price-desc') {
              sorted.sort(function (a, b) { return Number(b.getAttribute('data-price')) - Number(a.getAttribute('data-price')); });
            } else if (mode === 'name-asc') {
              sorted.sort(function (a, b) { return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), 'fr'); });
            } else {
              return; /* "Trier" (default) — leave the original server-rendered order untouched */
            }
            sorted.forEach(function (item) { grid.appendChild(item); });
          });
        }
      } catch (e) {
        /* Sort failed to initialize — grid just keeps its original order. */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowers-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-flowers]').forEach(function (root) {
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-flowers-filter]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-flowers-item]'));
      var grid = root.querySelector('[data-flowers-grid]');
      var count = root.querySelector('[data-flowers-count]');
      var noMatch = root.querySelector('[data-flowers-no-match]');
      var reset = root.querySelector('[data-flowers-reset]');
      if (!selects.length || !items.length) return;

      /* Couleur is multi-select (item 4): OR within this one filter
         (any card whose own data-couleurs list intersects the active
         set matches), AND against Fleur/Signification like before.
         activeCouleurs is the single source of truth, kept in sync
         across the desktop dropdown AND the mobile sheet's checkboxes
         (same values in both — checking one checks the other). */
      var couleurCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-couleur-option]'));
      var activeCouleurs = [];

      function syncCouleurCheckboxes() {
        couleurCheckboxes.forEach(function (cb) {
          cb.checked = activeCouleurs.indexOf(cb.value) !== -1;
        });
      }

      function couleurSummaryLabel() {
        if (activeCouleurs.length === 0) return 'Couleur';
        if (activeCouleurs.length === 1) {
          var cb = couleurCheckboxes.filter(function (c) { return c.value === activeCouleurs[0]; })[0];
          var text = cb ? cb.closest('label').querySelector('span:last-child').textContent : activeCouleurs[0];
          return text;
        }
        return 'Couleur · ' + activeCouleurs.length;
      }

      function apply() {
        var active = {};
        var anyActive = activeCouleurs.length > 0;
        selects.forEach(function (s) {
          if (s.value) { active[s.dataset.flowersFilter] = s.value; anyActive = true; }
        });
        var shown = 0;
        items.forEach(function (item) {
          var match = true;
          if (active.fleur && item.getAttribute('data-fleur') !== active.fleur) {
            match = false;
          }
          if (match && active.signification) {
            var sigs = (item.getAttribute('data-significations') || '').split(' ').filter(Boolean);
            if (sigs.indexOf(active.signification) === -1) match = false;
          }
          if (match && activeCouleurs.length) {
            var cols = (item.getAttribute('data-couleurs') || '').split(' ').filter(Boolean);
            var hit = activeCouleurs.some(function (c) { return cols.indexOf(c) !== -1; });
            if (!hit) match = false;
          }
          item.hidden = !match;
          if (match) shown++;
        });
        if (grid) grid.hidden = shown === 0;
        if (noMatch) noMatch.hidden = shown !== 0;
        if (count) {
          count.textContent = shown === items.length
            ? ''
            : shown + (shown > 1 ? ' fleurs' : ' fleur');
        }
        if (reset) reset.hidden = !anyActive;
      }

      selects.forEach(function (s) { s.addEventListener('change', apply); });
      if (reset) {
        reset.addEventListener('click', function () {
          selects.forEach(function (s) { s.value = ''; });
          activeCouleurs = [];
          syncCouleurCheckboxes();
          apply();
          syncAllChips();
        });
      }

      /* ---------------- Mobile/tablet bottom-sheet filters ----------------
         The real <select> elements stay the only source of truth — apply()
         above keeps doing 100% of the actual filtering, completely
         untouched. This layer only presents a chip bar + one bottom sheet
         at a time; picking an option inside a sheet is a pending choice,
         committed to the matching <select> (value + dispatched 'change')
         only when "Voir les fleurs" is pressed. Everything is scoped to
         `root`/its own elements — no listener on document/body/window,
         nothing global, matching the section's anti-regression rule.

         Wrapped in try/catch: [data-premium-ready] is only set on root
         once this has wired up without error AND the essential elements
         (chips + sheets) actually exist. The CSS only switches from the
         native selects to this chip bar once that attribute is present —
         so any JS error here leaves the native Fleur/Signification/Couleur
         selects visible and fully functional instead of hiding everything. */
      try {
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-chip]'));
      var sheets = Array.prototype.slice.call(root.querySelectorAll('[data-flowers-sheet]'));
      var resetCompact = root.querySelector('[data-flowers-reset-compact]');
      var sheetScrollY = 0;

      function lockSheetScroll() {
        sheetScrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = -sheetScrollY + 'px';
        document.body.style.width = '100%';
        document.body.classList.add('flowers-sheet-open');
      }

      function unlockSheetScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.classList.remove('flowers-sheet-open');
        window.scrollTo(0, sheetScrollY);
      }

      function resetPanelDrag(panel) {
        if (!panel) return;
        panel.style.transition = '';
        panel.style.transform = '';
      }

      function closeAllSheets() {
        var wasOpen = false;
        sheets.forEach(function (sheet) {
          if (!sheet.hidden) wasOpen = true;
          sheet.hidden = true;
          resetPanelDrag(sheet.querySelector('.flowers__sheet-panel'));
        });
        chips.forEach(function (chip) {
          var openBtn = chip.querySelector('[data-chip-open]');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (wasOpen) unlockSheetScroll();
      }

      /* Swipe-down-to-close, bound only to the handle and the header (never
         the scrollable option list, so list scrolling stays completely
         native). No competing horizontal gesture exists on these two
         elements (just a title/close button, or an empty handle), so drag
         intent only needs a single check — downward movement past ~10px —
         instead of the dx/dy direction race used for the horizontal
         swipes elsewhere in the theme (assets/cart.js): that race can
         permanently cancel tracking off one noisy early sample (a real
         thumb rarely moves in a perfectly straight line), which is why the
         first version of this gesture didn't reliably close. Here every
         pointermove is re-evaluated until the threshold is crossed, so a
         wobbly start doesn't kill the gesture. The panel visibly follows
         the finger (translateY) while dragging, snaps back if released
         short of the close distance, or closes if released past it. Mouse
         is ignored outright, pointer capture is deferred until a real drag
         is confirmed (so a plain tap still reaches the handle/close
         button's own click normally), and there's no preventDefault
         anywhere so this can never block a scroll or a native click. */
      function bindSheetSwipeDown(el, sheet) {
        if (!el || !sheet) return;
        var panel = sheet.querySelector('.flowers__sheet-panel');
        if (!panel) return;

        var tracking = false;
        var dragging = false;
        var pointerId = null;
        var startY = 0;
        var lastDy = 0;
        var lastMoveY = 0;
        var lastMoveTime = 0;
        var velocity = 0;
        var INTENT_THRESHOLD = 10;
        var CLOSE_MIN = 70;
        var CLOSE_RATIO = 0.22;
        var FLING_VELOCITY = 0.5; /* px/ms — a quick short flick closes even
                                      short of the distance threshold, same
                                      as native iOS/Android bottom sheets */

        function endDrag() {
          if (!tracking) return;
          var wasDragging = dragging;
          tracking = false;
          dragging = false;
          if (!wasDragging) return;
          var closeDistance = Math.max(CLOSE_MIN, panel.clientHeight * CLOSE_RATIO);
          if (lastDy > closeDistance || (lastDy > INTENT_THRESHOLD && velocity > FLING_VELOCITY)) {
            closeAllSheets();
          } else {
            panel.style.transition = 'transform 0.2s ease-out';
            panel.style.transform = '';
          }
          lastDy = 0;
          velocity = 0;
        }

        el.addEventListener(
          'pointerdown',
          function (e) {
            if (e.pointerType === 'mouse') return;
            tracking = true;
            dragging = false;
            pointerId = e.pointerId;
            startY = e.clientY;
            lastMoveY = e.clientY;
            lastMoveTime = e.timeStamp;
            velocity = 0;
            panel.style.transition = 'none';
          },
          { passive: true }
        );

        el.addEventListener(
          'pointermove',
          function (e) {
            if (!tracking || e.pointerId !== pointerId) return;
            var dy = e.clientY - startY;
            if (!dragging) {
              if (dy < INTENT_THRESHOLD) return;
              dragging = true;
              if (el.setPointerCapture) {
                try {
                  el.setPointerCapture(pointerId);
                } catch (err) {
                  /* capture is best-effort; gesture still works without it */
                }
              }
            }
            var dt = e.timeStamp - lastMoveTime;
            if (dt > 0) velocity = (e.clientY - lastMoveY) / dt;
            lastMoveY = e.clientY;
            lastMoveTime = e.timeStamp;
            lastDy = Math.max(0, dy);
            panel.style.transform = 'translateY(' + lastDy + 'px)';
          },
          { passive: true }
        );

        el.addEventListener('pointerup', function (e) {
          if (e.pointerId !== pointerId) return;
          endDrag();
        }, { passive: true });

        el.addEventListener('pointercancel', function (e) {
          if (e.pointerId !== pointerId) return;
          tracking = false;
          dragging = false;
          lastDy = 0;
          velocity = 0;
          resetPanelDrag(panel);
        });
      }

      function filterSheetList(sheet, query) {
        var list = sheet.querySelector('[data-sheet-list]');
        var empty = sheet.querySelector('[data-sheet-search-empty]');
        if (!list) return;
        var q = query.trim().toLowerCase();
        var visible = 0;
        list.querySelectorAll('[data-filter-option]').forEach(function (o) {
          var text = o.dataset.searchText || '';
          var match = q === '' || text.indexOf(q) !== -1;
          o.hidden = !match;
          if (match) visible++;
        });
        if (empty) empty.hidden = visible !== 0;
      }

      function openSheet(key) {
        closeAllSheets();
        var sheet = root.querySelector('[data-flowers-sheet="' + key + '"]');
        var chip = root.querySelector('[data-chip="' + key + '"]');
        var select = root.querySelector('[data-flowers-filter="' + key + '"]');
        if (!sheet) return;
        if (key !== 'couleur' && !select) return;
        sheet.hidden = false;
        resetPanelDrag(sheet.querySelector('.flowers__sheet-panel'));
        if (chip) {
          var openBtn = chip.querySelector('[data-chip-open]');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        }
        lockSheetScroll();
        if (key === 'couleur') {
          syncCouleurCheckboxes();
          return;
        }
        var list = sheet.querySelector('[data-sheet-list]');
        if (list) {
          list.querySelectorAll('[data-filter-option]').forEach(function (o) {
            o.setAttribute('aria-pressed', o.dataset.filterOption === select.value ? 'true' : 'false');
          });
        }
        var search = sheet.querySelector('[data-sheet-search]');
        if (search) {
          search.value = '';
          filterSheetList(sheet, '');
        }
      }

      sheets.forEach(function (sheet) {
        var key = sheet.dataset.flowersSheet;
        var select = root.querySelector('[data-flowers-filter="' + key + '"]');

        sheet.querySelectorAll('[data-sheet-close]').forEach(function (el) {
          el.addEventListener('click', closeAllSheets);
        });

        bindSheetSwipeDown(sheet.querySelector('.flowers__sheet-handle'), sheet);
        bindSheetSwipeDown(sheet.querySelector('.flowers__sheet-header'), sheet);

        if (key === 'couleur') {
          /* Multi-select: picking a checkbox never closes the sheet
             (item 4) — the mobile checkboxes here and the desktop
             dropdown's own checkboxes share the same values, so a
             change on either side is mirrored to the other. Nothing is
             actually applied to the grid until "Voir les fleurs"
             (below) or the global chip clear is pressed. */
          sheet.querySelectorAll('[data-couleur-option]').forEach(function (cb) {
            cb.addEventListener('change', function () {
              couleurCheckboxes.forEach(function (other) {
                if (other.value === cb.value) other.checked = cb.checked;
              });
            });
          });
          var couleurApplyBtn = sheet.querySelector('[data-couleur-apply]');
          if (couleurApplyBtn) {
            couleurApplyBtn.addEventListener('click', function () {
              activeCouleurs = couleurCheckboxes
                .filter(function (cb) { return cb.checked; })
                .map(function (cb) { return cb.value; })
                .filter(function (v, i, arr) { return arr.indexOf(v) === i; });
              apply();
              syncAllChips();
              closeAllSheets();
            });
          }
          var couleurClearBtn = sheet.querySelector('[data-couleur-clear]');
          if (couleurClearBtn) {
            couleurClearBtn.addEventListener('click', function () {
              activeCouleurs = [];
              syncCouleurCheckboxes();
              apply();
              syncAllChips();
            });
          }
          return;
        }

        if (!select) return;

        sheet.querySelectorAll('[data-filter-option]').forEach(function (opt) {
          opt.addEventListener('click', function () {
            sheet.querySelectorAll('[data-filter-option]').forEach(function (o) {
              o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
            });
          });
        });

        var applyBtn = sheet.querySelector('[data-sheet-apply]');
        if (applyBtn) {
          applyBtn.addEventListener('click', function () {
            var pending = sheet.querySelector('[data-filter-option][aria-pressed="true"]');
            select.value = pending ? pending.dataset.filterOption : '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
            closeAllSheets();
          });
        }

        var search = sheet.querySelector('[data-sheet-search]');
        if (search) {
          search.addEventListener('input', function () {
            filterSheetList(sheet, search.value);
          });
        }
      });

      function syncChip(key) {
        var chip = root.querySelector('[data-chip="' + key + '"]');
        if (!chip) return;
        var label = chip.querySelector('[data-chip-label]');
        var arrow = chip.querySelector('[data-chip-arrow]');
        var clearBtn = chip.querySelector('[data-chip-clear]');
        if (!label) return;
        var defaultLabel = chip.dataset.defaultLabel || label.textContent;
        chip.dataset.defaultLabel = defaultLabel;

        if (key === 'couleur') {
          if (activeCouleurs.length) {
            label.textContent = couleurSummaryLabel();
            if (arrow) arrow.hidden = true;
            if (clearBtn) clearBtn.hidden = false;
          } else {
            label.textContent = defaultLabel;
            if (arrow) arrow.hidden = false;
            if (clearBtn) clearBtn.hidden = true;
          }
          return;
        }

        var select = root.querySelector('[data-flowers-filter="' + key + '"]');
        if (!select) return;
        var selectedOption = select.options[select.selectedIndex];
        if (select.value && selectedOption) {
          label.textContent = selectedOption.textContent;
          if (arrow) arrow.hidden = true;
          if (clearBtn) clearBtn.hidden = false;
        } else {
          label.textContent = defaultLabel;
          if (arrow) arrow.hidden = false;
          if (clearBtn) clearBtn.hidden = true;
        }
      }

      function syncAllChips() {
        chips.forEach(function (chip) { syncChip(chip.dataset.chip); });
        if (resetCompact) {
          var anyActive = selects.some(function (s) { return s.value; }) || activeCouleurs.length > 0;
          resetCompact.hidden = !anyActive;
        }
        syncDesktopCouleurSummary();
      }

      function syncDesktopCouleurSummary() {
        var summary = root.querySelector('[data-couleur-summary-label]');
        if (summary) summary.textContent = couleurSummaryLabel();
      }

      chips.forEach(function (chip) {
        var key = chip.dataset.chip;
        var openBtn = chip.querySelector('[data-chip-open]');
        var clearBtn = chip.querySelector('[data-chip-clear]');

        if (key === 'couleur') {
          syncChip(key);
          if (openBtn) {
            openBtn.addEventListener('click', function () { openSheet(key); });
          }
          if (clearBtn) {
            clearBtn.addEventListener('click', function () {
              activeCouleurs = [];
              syncCouleurCheckboxes();
              apply();
              syncAllChips();
            });
          }
          return;
        }

        var select = root.querySelector('[data-flowers-filter="' + key + '"]');
        if (!select) return;

        syncChip(key);
        select.addEventListener('change', function () { syncChip(key); syncAllChips(); });

        if (openBtn) {
          openBtn.addEventListener('click', function () { openSheet(key); });
        }
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            select.value = '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      });

      /* Desktop couleur dropdown (<details>) — its own apply/clear
         buttons mirror the mobile sheet's exactly (item 4: same staged-
         apply behaviour on every breakpoint). Closing the <details> on
         apply/clear keeps it from staying open after the grid updates. */
      var couleurDropdown = root.querySelector('[data-couleur-dropdown]');
      if (couleurDropdown) {
        couleurDropdown.querySelectorAll('[data-couleur-option]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            couleurCheckboxes.forEach(function (other) {
              if (other.value === cb.value) other.checked = cb.checked;
            });
          });
        });
        var desktopApply = couleurDropdown.querySelector('[data-couleur-apply]');
        if (desktopApply) {
          desktopApply.addEventListener('click', function () {
            activeCouleurs = couleurCheckboxes
              .filter(function (cb) { return cb.checked; })
              .map(function (cb) { return cb.value; })
              .filter(function (v, i, arr) { return arr.indexOf(v) === i; });
            apply();
            syncAllChips();
            couleurDropdown.removeAttribute('open');
          });
        }
        var desktopClear = couleurDropdown.querySelector('[data-couleur-clear]');
        if (desktopClear) {
          desktopClear.addEventListener('click', function () {
            activeCouleurs = [];
            syncCouleurCheckboxes();
            apply();
            syncAllChips();
          });
        }
      }
      syncDesktopCouleurSummary();

      if (resetCompact) {
        resetCompact.addEventListener('click', function () {
          if (reset) reset.click();
          syncAllChips();
        });
      }

      syncAllChips();

      if (chips.length && sheets.length) {
        root.setAttribute('data-premium-ready', 'true');
      }
      } catch (e) {
        /* Premium UI failed to initialize — root never gets
           [data-premium-ready], so the CSS fallback keeps the native
           Fleur/Signification/Couleur selects visible on mobile/tablet. */
      }

      /* ---------------- 2/1-column view toggle (mobile/tablet) ----------------
         Same principle as the collection page's own selector
         (sections/main-collection.liquid, data-view-toggle / localStorage
         key "oxalis:collection-view"): a purely visual preference, toggled
         independently of the Fleur/Signification/Couleur filters above (it
         only flips a class on the stable [data-flowers] root, the filters'
         own try/catch above is completely separate) and stored under its
         own localStorage key so it never reads or overwrites the shop's
         collection-view choice. Wrapped in its own try/catch so a failure
         here can never take down the filters, and vice versa. */
      try {
        var VIEW_KEY = 'oxalis:flowers-view';
        var viewToggle = root.querySelector('[data-flowers-view-toggle]');
        if (viewToggle) {
          var applyView = function (mode) {
            root.classList.toggle('flowers--view-full', mode === '1');
            viewToggle.querySelectorAll('[data-flowers-view-btn]').forEach(function (btn) {
              var active = btn.getAttribute('data-flowers-view-btn') === mode;
              btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
          };

          var savedView = '2';
          try {
            savedView = localStorage.getItem(VIEW_KEY) || '2';
          } catch (storageErr) {
            /* private mode / storage disabled — default view, harmless */
          }
          applyView(savedView);

          viewToggle.querySelectorAll('[data-flowers-view-btn]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var mode = btn.getAttribute('data-flowers-view-btn');
              applyView(mode);
              try {
                localStorage.setItem(VIEW_KEY, mode);
              } catch (storageErr) {
                /* best-effort only — the choice just won't persist */
              }
            });
          });
        }
      } catch (e) {
        /* View toggle failed to initialize — the grid just stays at its
           CSS default (2 columns on mobile/tablet), filters unaffected. */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('[data-gallery-track]');
      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      if (!track) return;

      function step() {
        return Math.max(track.clientWidth * 0.85, 220);
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 1;
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        if (prev) prev.hidden = !overflowing || track.scrollLeft <= 1;
        if (next) next.hidden = !overflowing || track.scrollLeft >= max;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      });
      window.addEventListener('resize', update);

      update();
      window.setTimeout(update, 300);
    }

    document.querySelectorAll('[data-gallery-carousel]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide"]) return;
  try {
    
  (function () {
    'use strict';
    var root = document.querySelector('[data-gift-guide]');
    if (!root) return;

    var STEP_COUNT = 4;
    var STATE_KEYS = ['pourQui', 'occasion', 'budget', 'type'];
    // "Quel type de création ?" (step 3) is the one multi-select step —
    // state.type is an array there, toggled per chip; every other step
    // stays single-select (state[key] is a plain string, replaced on click).
    var MULTI_STEP_INDEX = 3;
    var state = { type: [] };
    var stepIndex = 0;

    var wizard = root.querySelector('[data-gg-wizard]');
    var stepEls = Array.prototype.slice.call(root.querySelectorAll('[data-gg-step]'));
    var dots = root.querySelectorAll('[data-gg-dot]');
    var backBtn = root.querySelector('[data-gg-back]');
    var resetBtn = root.querySelector('[data-gg-reset]');
    var nextBtn = root.querySelector('[data-gg-next]');
    var resultsEl = root.querySelector('[data-gg-results]');
    var gridEl = root.querySelector('[data-gg-grid]');
    var emptyEl = root.querySelector('[data-gg-empty]');
    var broadenedEl = root.querySelector('[data-gg-broadened]');
    var restartBtn = root.querySelector('[data-gg-restart]');
    var datasetEl = root.querySelector('[data-gg-dataset]');

    var dataset = [];
    try {
      dataset = JSON.parse(datasetEl.textContent);
    } catch (e) {
      dataset = [];
    }

    function stepElAt(i) {
      return stepEls[i];
    }

    function setActiveChip(stepEl, valueOrValues) {
      // Accepts either a single value (steps 0-2) or an array of values
      // (step 3, multi-select) — normalised to an array once here so every
      // chip's active state is just an `indexOf` check either way.
      var values = Array.isArray(valueOrValues) ? valueOrValues : [valueOrValues];
      stepEl.querySelectorAll('[data-value]').forEach(function (btn) {
        var active = values.indexOf(btn.getAttribute('data-value')) !== -1;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function showStep(i) {
      stepEls.forEach(function (el, idx) {
        el.hidden = idx !== i;
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
      backBtn.hidden = i === 0;
      nextBtn.textContent =
        i === STEP_COUNT - 1
          ? nextBtn.getAttribute('data-label-finish')
          : nextBtn.getAttribute('data-label-next');
      setActiveChip(stepElAt(i), state[STATE_KEYS[i]]);
      nextBtn.disabled = i === MULTI_STEP_INDEX ? state.type.length === 0 : !state[STATE_KEYS[i]];
    }

    stepEls.forEach(function (stepEl, i) {
      stepEl.querySelectorAll('[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-value');
          if (i === MULTI_STEP_INDEX) {
            // Each category toggles independently — add if not yet
            // selected, remove if it already was.
            var idx = state.type.indexOf(val);
            if (idx === -1) {
              state.type.push(val);
            } else {
              state.type.splice(idx, 1);
            }
          } else {
            state[STATE_KEYS[i]] = val;
            /* Budget chips carry their real price band as data-min/data-max
               (cents) — captured alongside the label so scoreEntry() can
               match the real Shopify price, never re-parsing the label. */
            if (btn.hasAttribute('data-min')) {
              state.budgetMin = Number(btn.getAttribute('data-min'));
              state.budgetMax = Number(btn.getAttribute('data-max'));
            }
          }
          setActiveChip(stepEl, state[STATE_KEYS[i]]);
          nextBtn.disabled = i === MULTI_STEP_INDEX ? state.type.length === 0 : false;
        });
      });
    });

    nextBtn.addEventListener('click', function () {
      if (nextBtn.disabled) return;
      if (stepIndex < STEP_COUNT - 1) {
        stepIndex += 1;
        showStep(stepIndex);
      } else {
        showResults();
      }
    });

    backBtn.addEventListener('click', function () {
      if (stepIndex === 0) return;
      stepIndex -= 1;
      wizard.hidden = false;
      resultsEl.hidden = true;
      showStep(stepIndex);
    });

    function resetAll() {
      state = { type: [] };
      stepIndex = 0;
      wizard.hidden = false;
      resultsEl.hidden = true;
      showStep(0);
    }
    resetBtn.addEventListener('click', resetAll);
    restartBtn.addEventListener('click', resetAll);

    // "Bijou coquillage" and "Bijou perle" are real data (entry.univers),
    // matched per entry like any other real signal. "Bijou fleuri" has no
    // such marker on the 96 original demo products (they predate
    // custom.univers), so it's still inferred the same way it always was:
    // having a fleur at all. "Bijou gravé", "Herbier" and "Objet gravé"
    // have no real product data yet, so they never match anything here —
    // selecting one of them always yields an empty result, by design (see
    // the hard filter in showResults() below). The chip label is plural
    // ("Bijou perles") while the real univers value is singular ("Bijou
    // perle") — mapped here, nowhere else.
    function entryTypeCreation(entry) {
      if (entry.univers === 'Bijou coquillage') return 'Bijou coquillage';
      if (entry.univers === 'Bijou perle') return 'Bijou perles';
      if (entry.fleur) return 'Bijou fleuri';
      return null;
    }
    // Type, budget and availability are the only HARD filters — a product
    // failing any of these is never shown, no exceptions, no broadening.
    // Type is multi-select (OR): a product matches as soon as its own type
    // is any one of the selected categories.
    function entryMatchesType(entry) {
      var t = entryTypeCreation(entry);
      return t != null && state.type.indexOf(t) !== -1;
    }
    function entryMatchesBudget(entry) {
      return (
        typeof entry.price === 'number' &&
        state.budgetMin != null &&
        entry.price >= state.budgetMin &&
        entry.price <= state.budgetMax
      );
    }

    // Editorial colour → occasion relevance table — centralised here, the
    // one place to adjust it. These are *hints*, never exclusions: a
    // colour absent from this table (e.g. "Doré", "Marron" on some Bijoux
    // perles) simply contributes no bonus, it never excludes the product
    // (see scoreEntry() below, which only ever adds points on top of the
    // strict univers/budget/availability pool).
    var COLOR_OCCASIONS = {
      'rouge': ['Saint-Valentin', 'Mariage', 'Anniversaire'],
      'orange': ['Anniversaire', 'Remerciement'],
      'rose': ['Fête des mères', 'Naissance', 'Anniversaire'],
      'blanc': ['Baptême', 'Mariage', 'Naissance', 'Fête des mères'],
      'bleu': ['Remerciement', 'Mariage', 'Anniversaire'],
      'mauve': ['Anniversaire', 'Fête des mères'],
      'violet': ['Anniversaire', 'Fête des mères'],
      'vert': ['Naissance', 'Anniversaire'],
      'jaune': ['Anniversaire', 'Remerciement'],
      'noir': ['Anniversaire', 'Saint-Valentin'],
      'beige': ['Mariage', 'Remerciement'],
      'naturel': ['Mariage', 'Remerciement']
    };
    // A product's couleur is a single value today, but this also copes
    // with a future multi-colour value (e.g. "Bleu/Blanc") by splitting on
    // common separators — one bonus max per product, never stacked.
    function colorMatchesOccasion(couleur, occasion) {
      if (!couleur || !occasion) return false;
      return String(couleur)
        .split(/[,/]| et | & |\+/i)
        .some(function (part) {
          var key = part.trim().toLowerCase();
          var list = COLOR_OCCASIONS[key];
          return list && list.indexOf(occasion) !== -1;
        });
    }

    // Pour qui / occasion / couleur are WEIGHTED ranking signals, not hard
    // filters — a product with none of custom.pour_qui, custom.occasion or
    // a relevant custom.couleur set still appears (ranked lower), so a
    // brand-new, untagged product is never invisible. Weights: an explicit
    // staff-set pour_qui/occasion match counts for more than the editorial
    // colour inference, by design.
    function scoreEntry(entry) {
      var score = 0;
      if (Array.isArray(entry.pour_qui) && entry.pour_qui.indexOf(state.pourQui) !== -1) score += 3;
      if (Array.isArray(entry.occasion) && entry.occasion.indexOf(state.occasion) !== -1) score += 3;
      if (colorMatchesOccasion(entry.couleur, state.occasion)) score += 2;
      return score;
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function money(cents) {
      return (cents / 100).toLocaleString('fr-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function heartSvg() {
      return (
        '<svg class="icon icon--heart" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" ' +
        'd="M12 20.5c-4.7-3-9-6.4-9-11A5 5 0 0 1 12 6a5 5 0 0 1 9 3.5c0 4.6-4.3 8-9 11z"/></svg>'
      );
    }
    // `entry` is the matched dataset row alongside the fetched live
    // product `p` — used only to show the flower's own signification
    // (Bijoux fleuris only, when set) as a small caption. Real data,
    // never invented: no caption at all when either is missing.
    function buildCard(p, entry) {
      var img = p.featured_image || (p.media && p.media[0] && p.media[0].src) || '';
      var price = money(p.price);
      if (p.compare_at_price && p.compare_at_price > p.price) {
        price =
          '<span class="product-card__price-sale">' + money(p.price) + '</span> ' +
          '<s class="product-card__price-was">' + money(p.compare_at_price) + '</s>';
      }
      var favActive = window.OxalisWishlist && window.OxalisWishlist.has(p.handle);
      var meaning =
        entry && entry.fleur && entry.signification
          ? '<p class="product-card__meaning">' + esc(entry.fleur) + ' — ' + esc(entry.signification) + '</p>'
          : '';
      var el = document.createElement('div');
      el.className = 'product-card';
      el.innerHTML =
        '<a class="product-card__media product-card__media--portrait" href="' + p.url + '">' +
        (img ? '<img class="product-card__img" src="' + img + '&width=600" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<button type="button" class="product-card__fav" data-wishlist-toggle data-product-handle="' + p.handle + '" aria-pressed="' + (favActive ? 'true' : 'false') + '" aria-label="' + (favActive ? 'Retirer des favoris' : 'Ajouter aux favoris') + '">' + heartSvg() + '</button>' +
        '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3><p class="product-card__price">' + price + '</p>' + meaning + '</div>';
      return el;
    }

    function showResults() {
      wizard.hidden = true;
      resultsEl.hidden = false;
      broadenedEl.hidden = true;
      emptyEl.hidden = true;
      gridEl.innerHTML = '';

      // Strict pool: only type (univers), budget and real availability —
      // a product failing any of these three is never shown, no
      // exceptions. This is the one and only hard filter.
      var pool = dataset
        .filter(function (e) {
          return e.available;
        })
        .filter(entryMatchesType)
        .filter(entryMatchesBudget);

      if (!pool.length) {
        emptyEl.hidden = false;
        return;
      }

      // Pour qui / occasion / couleur rank this already-strict pool —
      // stable sort (Array#sort is stable in every supported browser)
      // keeps catalogue order among equal scores, so results don't jitter.
      var scored = pool
        .map(function (e) {
          return { entry: e, score: scoreEntry(e) };
        })
        .sort(function (a, b) {
          return b.score - a.score;
        });

      var picks = scored.slice(0, 8);
      // Nothing in the top picks matched any real pour_qui/occasion/couleur
      // signal — still real, in-budget, in-univers products, never a blank
      // screen, but flagged so the visitor knows the match is looser.
      broadenedEl.hidden = picks[0].score > 0;

      Promise.all(
        picks.map(function (pick) {
          return fetch('/products/' + pick.entry.handle + '.js')
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (p) {
              return p ? { p: p, entry: pick.entry } : null;
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (results) {
        var frag = document.createDocumentFragment();
        results.filter(Boolean).forEach(function (r) {
          frag.appendChild(buildCard(r.p, r.entry));
        });
        if (!frag.childNodes.length) {
          emptyEl.hidden = false;
          return;
        }
        gridEl.appendChild(frag);
      });
    }

    showStep(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    'use strict';
    var KEY = 'oxalis:collection-view';
    var root = document.querySelector('[data-collection]');
    var toggle = document.querySelector('[data-view-toggle]');
    if (!root || !toggle) return;

    function apply(mode) {
      root.classList.toggle('collection--view-full', mode === '1');
      toggle.querySelectorAll('[data-view-btn]').forEach(function (btn) {
        var active = btn.getAttribute('data-view-btn') === mode;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    var saved = '2';
    try {
      saved = localStorage.getItem(KEY) || '2';
    } catch (e) {
      /* private mode / storage disabled — default view, harmless */
    }
    apply(saved);

    toggle.querySelectorAll('[data-view-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-view-btn');
        apply(mode);
        try {
          localStorage.setItem(KEY, mode);
        } catch (e) {
          /* best-effort only — the choice just won't persist */
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
  (function () {
    'use strict';
    try {
      var body = document.querySelector('[data-policy-body]');
      var chevronTpl = document.querySelector('[data-policy-chevron]');
      if (!body) return;

      var preamble = document.createElement('div');
      preamble.className = 'policy__preamble rte';
      var sections = [];
      var current = null;

      Array.prototype.forEach.call(body.childNodes, function (node) {
        if (node.nodeType === 1 && node.tagName === 'H2') {
          current = { title: node.textContent, content: document.createElement('div') };
          current.content.className = 'faq__answer rte';
          sections.push(current);
        } else if (current) {
          current.content.appendChild(node.cloneNode(true));
        } else {
          preamble.appendChild(node.cloneNode(true));
        }
      });

      // Nothing to restructure (no <h2> chapters) — leave the flat document as-is.
      if (!sections.length) return;

      var list = document.createElement('div');
      list.className = 'faq__list';

      sections.forEach(function (section) {
        var details = document.createElement('details');
        details.className = 'faq__item';

        var summary = document.createElement('summary');
        summary.className = 'faq__question';
        var label = document.createElement('span');
        label.textContent = section.title;
        summary.appendChild(label);
        if (chevronTpl) summary.appendChild(chevronTpl.content.cloneNode(true));

        details.appendChild(summary);
        details.appendChild(section.content);
        list.appendChild(details);
      });

      var wrapper = document.createElement('div');
      if (preamble.childNodes.length) wrapper.appendChild(preamble);
      wrapper.appendChild(list);

      body.replaceWith(wrapper);
    } catch (e) {
      /* Any failure here simply leaves the original flat document visible
         (see above) — the legal text itself is never at risk. */
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* Chain-extension checkbox → selects the real Shopify variant (no fake price). */
  document.querySelectorAll('[data-extension-option]').forEach(function (fs) {
    var check = fs.querySelector('[data-extension-check]');
    var radios = fs.querySelectorAll('[data-extension-radio]');
    if (!check || !radios.length) return;
    check.addEventListener('change', function () {
      var want = check.checked ? 'on' : 'off';
      radios.forEach(function (r) {
        var match = r.getAttribute('data-extension-radio') === want;
        r.checked = match;
        if (match) r.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-require-nonblank]').forEach(function (field) {
    function check() {
      var v = field.value;
      field.setCustomValidity(v.length > 0 && v.trim() === '' ? field.dataset.requireNonblank : '');
    }
    field.addEventListener('input', check);
    check();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  (function () {
    'use strict';

    var KEY = 'oxalis:recently-viewed';
    var MAX_ENTRIES = 12;
    var MAX_AGE_DAYS = 60;

    var root = document.querySelector('[data-recently-viewed]');
    if (!root) return;
    var grid = root.querySelector('[data-recently-viewed-grid]');
    var currentHandle = root.getAttribute('data-current-handle') || null;

    function read() {
      try {
        var list = JSON.parse(localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(list)) return [];
        var cutoff = Date.now() - MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
        return list.filter(function (entry) {
          return (
            entry &&
            typeof entry.handle === 'string' &&
            typeof entry.viewedAt === 'number' &&
            entry.viewedAt >= cutoff
          );
        });
      } catch (e) {
        return [];
      }
    }

    function write(list) {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {
        /* private mode / storage disabled — recording is best-effort only */
      }
    }

    // Record the current product as viewed: handle + timestamp only, never
    // a copy of product data. Deduplicated (moves to the front rather than
    // appearing twice) and capped at MAX_ENTRIES, most-recent-first.
    if (currentHandle) {
      var updated = read().filter(function (entry) {
        return entry.handle !== currentHandle;
      });
      updated.unshift({ handle: currentHandle, viewedAt: Date.now() });
      write(updated.slice(0, MAX_ENTRIES));
    }

    if (!grid) return;

    var handles = read()
      .map(function (entry) {
        return entry.handle;
      })
      .filter(function (h) {
        return h !== currentHandle; // never list the page you're already on
      });

    // Storage remembers up to MAX_ENTRIES products, but this row only ever
    // displays a handful — capping the fetch count too means a product
    // page never fires more small requests than it actually shows.
    var DISPLAY_LIMIT = 8;
    handles = handles.slice(0, DISPLAY_LIMIT);

    if (!handles.length) return; // nothing to show — stays hidden

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function money(cents) {
      return (cents / 100).toLocaleString('fr-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function heartSvg() {
      return (
        '<svg class="icon icon--heart" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" ' +
        'd="M12 20.5c-4.7-3-9-6.4-9-11A5 5 0 0 1 12 6a5 5 0 0 1 9 3.5c0 4.6-4.3 8-9 11z"/></svg>'
      );
    }

    // Reuses the exact same product-card markup/classes as the favourites
    // page (assets/wishlist.js) and the real Liquid cards (snippets/
    // product-card.liquid), fetching each product's public JSON — no new
    // card design, no duplicated product data beyond what's already public.
    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var frag = document.createDocumentFragment();
      // A sold-out product is still listed (it may come back); a genuinely
      // removed product's fetch resolves null/404 and .filter(Boolean)
      // above already drops it.
      products.filter(Boolean).forEach(function (p) {
        var img = p.featured_image || (p.media && p.media[0] && p.media[0].src) || '';
        var price = money(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          price =
            '<span class="product-card__price-sale">' + money(p.price) + '</span> ' +
            '<s class="product-card__price-was">' + money(p.compare_at_price) + '</s>';
        }
        var favActive = window.OxalisWishlist && window.OxalisWishlist.has(p.handle);
        var el = document.createElement('div');
        el.className = 'product-card';
        el.innerHTML =
          '<a class="product-card__media product-card__media--portrait" href="' + p.url + '">' +
          (img ? '<img class="product-card__img" src="' + img + '&width=600" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="product-card__fav" data-wishlist-toggle data-product-handle="' + p.handle + '" aria-pressed="' + (favActive ? 'true' : 'false') + '" aria-label="' + (favActive ? 'Retirer des favoris' : 'Ajouter aux favoris') + '">' + heartSvg() + '</button>' +
          '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3><p class="product-card__price">' + price + '</p></div>';
        frag.appendChild(el);
      });
      if (!frag.childNodes.length) return; // every stored handle is gone now
      grid.appendChild(frag);
      root.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-require-nonblank]').forEach(function (field) {
    function check() {
      var v = field.value;
      field.setCustomValidity(v.length > 0 && v.trim() === '' ? field.dataset.requireNonblank : '');
    }
    field.addEventListener('input', check);
    check();
  });

  document.querySelectorAll('[data-stars]').forEach(function (group) {
    var starEls = Array.prototype.slice.call(group.querySelectorAll('.stars__star'));
    var canHover = window.matchMedia('(hover: hover)').matches;

    function paint(upTo) {
      starEls.forEach(function (star) {
        var value = parseInt(star.querySelector('input').dataset.starValue, 10);
        star.classList.toggle('is-filled', value <= upTo);
      });
    }

    function checkedValue() {
      var checked = group.querySelector('input:checked');
      return checked ? parseInt(checked.dataset.starValue, 10) : 0;
    }

    paint(checkedValue());

    starEls.forEach(function (star) {
      var input = star.querySelector('input');

      input.addEventListener('change', function () {
        paint(checkedValue());
      });

      if (canHover) {
        star.addEventListener('mouseenter', function () {
          paint(parseInt(input.dataset.starValue, 10));
        });
        star.addEventListener('mouseleave', function () {
          paint(checkedValue());
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signification-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sig-explorer').forEach(function (root) {
      var select = root.querySelector('[data-sig-select]');
      var grid = root.querySelector('[data-sig-grid]');
      var prompt = root.querySelector('[data-sig-prompt]');
      var empty = root.querySelector('[data-sig-empty]');
      var count = root.querySelector('[data-sig-count]');
      if (!select || !grid) return;
      var cells = Array.prototype.slice.call(grid.querySelectorAll('.sig-explorer__cell'));

      function apply(value) {
        if (!value) {
          grid.hidden = true;
          if (empty) empty.hidden = true;
          if (prompt) prompt.hidden = false;
          if (count) count.textContent = '';
          return;
        }
        var shown = 0;
        cells.forEach(function (cell) {
          var match = cell.getAttribute('data-sig') === value;
          cell.hidden = !match;
          if (match) shown++;
        });
        if (prompt) prompt.hidden = true;
        grid.hidden = shown === 0;
        if (empty) empty.hidden = shown !== 0;
        if (count) {
          count.textContent = shown === 0
            ? ''
            : shown + (shown > 1 ? ' créations' : ' création');
        }
      }

      select.addEventListener('change', function () {
        apply(select.value);
        try {
          var url = select.value
            ? '#signification=' + select.value
            : location.pathname + location.search;
          history.replaceState(null, '', url);
        } catch (e) {}
      });

      var fromHash = (location.hash.match(/^#signification=(.+)$/) || [])[1];
      if (fromHash) {
        fromHash = decodeURIComponent(fromHash);
        if (Array.prototype.some.call(select.options, function (o) { return o.value === fromHash; })) {
          select.value = fromHash;
          apply(fromHash);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
